/* TK 2026-08-22 — prefetch produktovych stranek, jakmile je karta na obrazovce.

   PROC: Shopify vyrenderuje PDP za ~40 ms, kdyz je URL v jeho full-page cache.
   Kdyz neni, je to 600-1240 ms (zmereno na hlubokem katalogu: 76, 35, 39, 55,
   47, 1241, 47, 603 ms). Vestavene Speculation Rules maji `eagerness: moderate`,
   tedy start az ~200 ms po najeti mysi — na 800 ms cold render to nestaci
   a v CDP trace to konci jako `PrefetchNotFinishedInTime`.

   Tenhle skript pusti prefetch uz ve chvili, kdy karta vjede do viewportu.
   Uzivatel na ni typicky jeste nekolik sekund kouka nez klikne, takze cold
   render Shopify probehne mezitim a klik uz jen zobrazi hotovou stranku.

   Meze, aby to nebylo na ukor dat:
     - najednou nejvyse MAX_LIVE URL, celkem nejvyse MAX_TOTAL za nacteni
     - jen produktove odkazy v hlavnim obsahu (ne menu, ne footer)
     - vypnuto pri saveData a na pomalych sitich
     - startuje az po `load`, aby nesoupeřilo s vykreslenim aktualni stranky */
(function () {
  var MAX_LIVE = 3;      // kolik URL je najednou v rulesetu
  var MAX_TOTAL = 10;    // strop za jedno nacteni stranky, at to nezere data
  var DWELL_MS = 450;    // jak dlouho musi karta zustat videt, nez ji prefetchnu

  if (!HTMLScriptElement.supports || !HTMLScriptElement.supports('speculationrules')) return;
  var c = navigator.connection;
  if (c) {
    if (c.saveData) return;
    // prefetch stahuje cele stranky navic — na pomalem pripojeni je to na skodu
    if (c.effectiveType && c.effectiveType !== '4g') return;
  }

  var queued = [];
  var seen = new Set();
  var tag = null;

  function flush() {
    if (!queued.length) return;
    if (tag) tag.remove();
    tag = document.createElement('script');
    tag.type = 'speculationrules';
    tag.textContent = JSON.stringify({
      prefetch: [{ source: 'list', urls: queued.slice(-MAX_LIVE), eagerness: 'immediate' }],
    });
    document.head.appendChild(tag);
  }

  function start() {
    var main = document.querySelector('#MainContent') || document.body;
    var links = main.querySelectorAll('a[href*="/products/"]');
    if (!links.length) return;

    /* Prefetchuje se az kdyz karta ZUSTANE videt DWELL_MS. Pri rychlem scrollovani
       kolem se tak nestahne nic — jen to, u ceho se uzivatel opravdu zastavi. */
    var timers = new WeakMap();

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var a = entries[i].target;
        if (!entries[i].isIntersecting) {
          if (timers.has(a)) { clearTimeout(timers.get(a)); timers.delete(a); }
          continue;
        }
        if (timers.has(a)) continue;
        timers.set(a, setTimeout(function (el) {
          return function () {
            timers.delete(el);
            io.unobserve(el);
            var u;
            try { u = new URL(el.href, location.href); } catch (e) { return; }
            if (u.origin !== location.origin) return;
            var key = u.pathname;
            if (seen.has(key) || seen.size >= MAX_TOTAL) return;
            seen.add(key);
            queued.push(key);
            flush();
          };
        }(a), DWELL_MS));
      }
    }, { rootMargin: '100px' });

    for (var i = 0; i < links.length; i++) io.observe(links[i]);
  }

  function boot() {
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 1500 });
    else setTimeout(start, 300);
  }
  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot, { once: true });
})();
